import { createStyles, makeStyles } from '@kis-technologies/kis-ui';

export const useStyles = makeStyles(() =>
  createStyles({
    menuPanelContainer: {
      width: '282px',
      background: 'white',
      color: '#2A2A2A'
    },
    menuPanelHeader: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      padding: '27px 16px 17px 24px',
      height: '80px'
    },
    menuPanelTabContainer: {
      background: 'transparent',
      justifyContent: 'space-between',
      display: 'flex',
      '& > * > *': {
        margin: '8px 0px'
      },
      '& > * > * > a': {
        padding: '4px 29px 4px 20px',
        minHeight: '38px'
      }
    },
    menuPanelButton: {
      width: '142px',
      height: '42px'
    },
    menuPanelFooter: {
      display: 'flex',
      flexDirection: 'column',
      background: 'transparent',
      alignItems: 'center',
      height: '160px'
    },
    menuPanelItemsBlock: {
      padding: '0px 0px 20px 0px',
      height: 'calc(100vh - 260px)',
      overflowY: 'auto'
    },
    infoText: {
      fontSize: '14px',
      lineHeight: '1.5',
      fontWeight: 600,
      textAlign: 'center',
      color: '#999999'
    }
  })
);
